module.exports = __webpack_public_path__ + "img/tga.0c3d63cf.png";